export const environment = {
	appUrl: 'https://beta.groin.le17-45.fr/',
	production: true,
	apiUrl: 'https://api.groin.le17-45.fr',
};
